import { z } from 'zod';
/** 차트 표시 전용 설정. 업무상의 임계값이나 집계 조건은 변경하지 않는다. */
export const ChartOptionsSchema = z.object({
    xAxis: z.boolean().default(true),
    yAxis: z.boolean().default(true),
    grid: z.boolean().default(true),
    tooltip: z.boolean().default(true),
    legend: z.boolean().default(true),
    threshold: z
        .object({
        value: z.number().finite(),
        label: z.string().trim().max(64).default('기준선'),
        color: z
            .string()
            .regex(/^#[0-9a-fA-F]{6}$/)
            .default('#dc2626'),
        axis: z.enum(['left', 'right']).default('left'),
    })
        .nullable()
        .default(null),
});
//# sourceMappingURL=chart-options.js.map